import React, { useState, useEffect, useRef } from 'react';
import { Button, Checkbox, FormControlLabel, Grid, MenuItem, Modal, Select } from '@material-ui/core';
import placeHolderProdImage from '../../../prod.png';
import './style.css';
import { isInViewport, SERVER_URL } from '../../../utils';
import ImageModel from '../ImageModel';
import { useSpring, animated } from 'react-spring';

const Mobile = (props) => {
  const [products, setProducts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const scrollRef = useRef(null);
  const indexRef = useRef(null);
  const scrollCheck = useRef(null);
  const {categorySlug, productType, selectedCallback} = props;
  let intervalID;

  console.log('productType', props.productType);



  //Sample address: http://localhost:3000/?id=55&name=test
  const queryParams = new URLSearchParams(window.location.search);
  let anyrace_product = 0;
  if (queryParams.get('anyrace_product')){
    anyrace_product = queryParams.get('anyrace_product');
  }


  useEffect(() => {
      if (props.categorySlug === '') {
        return;
      }
      fetch(`${SERVER_URL}/wp-json/anyrace_product_list/products_by_category_slug/${props.categorySlug}/${props.productType}`)
        .then((res) => {
          console.log('RES', res);
          return res.json()
        })
        .then((list) => {
          console.log("Products-List", list);
          setProducts(
            list
          );
          if (list.length > 0) {
            props.selectedCallback(list[anyrace_product]);
            setSelected(list[anyrace_product]);
            indexRef.current = 0;
          } else {
            props.selectedCallback([]);
            setSelected(null);
          }
          
        });
    }, [props.categorySlug]);
  
    if (props.categorySlug === '') {
      return <></>;
    }
  
  // const smoothScroll = (value, index) => {
  //   intervalID = setInterval(() => {
  //     scrollCheck.current += 1;
  //     if (value > 0) {
  //       scrollRef.current.scrollLeft += 1;
  //     } else {
  //       scrollRef.current.scrollLeft -= 1;
  //     }
      
  //     if (scrollCheck.current > 210) {
  //       clearInterval(intervalID)
  //     }
  //     console.log("scrollCheck", scrollCheck.current);
      
  //   }, 1);

  // }
  
  
  const selectProduct = (product, index) => {
    props.selectedCallback(product)
    setSelected(product);
    const offsetWidth = scrollRef.current.scrollWidth - scrollRef.current.offsetWidth;
    scrollCheck.current = 1;
    if (indexRef.current > index) {
      //smoothScroll(-1, index);
       scrollRef.current.scrollLeft -= 220;
    } else if (indexRef.current < index) {
      //smoothScroll(1, index);
      scrollRef.current.scrollLeft += 220;
    }
    console.log(scrollRef.current.scrollLeft, scrollRef.current.scrollWidth, scrollRef.current.offsetWidth);
    indexRef.current = index;

  }
  const handleImageOpen = (product) => {
    setImageModalOpen(true);
  };

  const handleImageClose = () => {
    setImageModalOpen(false);
  };

  function modifyServiceProductName(pName){
    const originalProductNameArray = pName.split(' ');
    //console.log('serviceName', originalProductNameArray);
    const shortenedProductNameArray = originalProductNameArray.filter(
        element => element !== 'BOS'
            && element !== 'Cane'
            && element !== 'Creek'
            && element !== 'Formula'
            && element !== 'FOX'
            && element !== 'Manitou'
            && element !== 'Marzocchi'
            && element !== 'Rockshox'
            && element !== 'RockShox'
    );
    //console.log('ShorterServiceName', shortenedProductNameArray);
    const result = shortenedProductNameArray.join(' ');
    return result;
  }

  const productsList = products.length > 0 && selected && products.map((entry, index) => (
    <div
      id={`product-${index}`}
      className={`product ${entry.id === selected.id ? 'selected' : ''}`}
      key={index}
      onClick={() => selectProduct(entry, index)}>
      <div className="Content">
        <div className="image-size-button-container">
          <div className="full-screen-icon" onClick={() => handleImageOpen(entry)}>
            <div className="icon bottom"></div>
            <div className="icon left"></div>
            <div className="icon top"></div>
            <div className="icon right"></div>
          </div>
        </div>
        <img src={entry.image ? entry.image : placeHolderProdImage} className="product-image" />
        
        <div className="product-name">{props.productType === 'service' ? modifyServiceProductName(entry.name) : entry.name}</div>
        <div className="product-price">€ {entry.price},-</div>
      </div>
      <div className="BottomTriangle">
        <div className="Border"></div>
      </div>
    </div>
  ));


  return (
    <div
      className="products-list-m"
      onScroll={(event) => {

        products.length > 0 && products.forEach((product, index) => {
          const box = document.querySelector(`#product-${index}`);
          if (isInViewport(box)) {
            props.selectedCallback(product)
            setSelected(product);
            indexRef.current = index;
          }
        });
        

      }}
      ref={scrollRef}>
      { products.length > 0 ?
        (
          <>
            <div div className={`product`} key={'first-prod'}>
              <div className="Content">
              </div>
            </div>
            {productsList}
            <div div className={`product`} key={'last-prod'}>
              <div className="Content">
              </div>
            </div>
          </>
        )
        :
        <Grid className="" style={{ cursor: 'default' }}>
          <p className={`no-product`} style={{ color: 'lightgrey' }}>No Products</p>
        </Grid>
      }
      {selected && <ImageModel
        open={imageModalOpen}
        handleClose={handleImageClose}
        product={selected}
      />}
    </div>
  )

}
  
export default Mobile;